import { render } from "./Tratamiento_Pedido.vue?vue&type=template&id=2bb58c3a"
import script from "./Tratamiento_Pedido.vue?vue&type=script&lang=js"
export * from "./Tratamiento_Pedido.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__